
















































































































import { ScrollButton } from "wings-ui-components";
import CallDetailIncomingFilter from "@/components/Call/Statistic/CallDetailIncomingFilter.vue";
import { DetailIncomingItem } from "@/store/call/statistic/types";
import { dateFilter } from "@/utils/date-util";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import BaseItemsPage from "../BaseItemsPage";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {CallDetailIncomingFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class CallDetailIncoming extends BaseItemsPage<DetailIncomingItem> {

  @Getter("callStatisticDetailIncoming") responseItems?: DetailIncomingItem[];

  is_show_filter = true;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'id', 'create_date', 'originator', 'service_number',
      'partner', 'content', 'status', 'error_code', 'detail',
    ];
  }

  getData() {
    return this.responseItems;
  }
}
